import styled from 'styled-components';
import { media } from 'utils/style';
import QuoteMessageError from 'components/QuoteMessageError/QuoteMessageError';

export default styled(QuoteMessageError)`
  width: 100%;
  .quote-message {
    &__banner {
      background-color: var(--grey100);
      padding: 2rem;
      border: 1px solid var(--grey500);
      border-radius: 4px;
      margin-bottom: 3rem;
      text-align: left;
      background: #fff2e0;
      border: 1px solid #fcc475;
      text-align: center;
      & svg path {
        fill: #e37012;
      }
      & svg {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 20px;
        height: 20px;
      }
    }
    &__message {
      margin: 2.6rem 0;
      margin-top: 0;
      font-size: 1.6rem;
      color: var(--grey800);
      font-weight: 500;
    }

    &__secondary-link {
      color: var(--primary500);
      font-weight: 700;
      text-decoration: none;
    }
  }

  .reachUsText {
    text-align: center;
    margin-bottom: 2rem;
    & span {
      display: block;
      ${media.lessThan('large')`
        display: inline;
      `}
    }
  }

  ${media.lessThan('extraSmall')`
        position: absolute;
        width: 100vw;
        left: 0;
        bottom: 0;
        border-radius: 0;
    `};
`;
